import React, {FC, memo} from 'react';

import {Job} from '../../models/jobs';
import {Card, CardImage, CardDescription, CardFooter, CardCities, CardDate} from './card';
import {getPublicUrl} from '../../utils/ImageCacheService';
import { FormattedMessage } from 'react-intl';
import generalMessages from '../../containers/generalMessages';
import { formatDatefromString } from '../../utils/date';
import P from '../Paragraph';
import {getCountryByCode} from '../../utils/country';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import { generatePath, Link } from 'react-router-dom';
import routes from '../../config/routes';
import H3 from '../Headings/H3';

interface IJobCard {
    job: Job,
}

const JobCard: FC<IJobCard> = ({job}) => {

    return (
        job ?
            <Card>
                <CardImage theme="job_img_size" to={generatePath(routes.JobsDetailByUrlSlug, {'industry': job.field_of_work, 'slug': job.slug})} className={job.partner_file_name || job.company_file_name ? '' : 'noImg'}>
                    {job.publisher === 'partner' ?
                        job.partner_file_name ?
                            <img data-src={getPublicUrl(job.partner_file_name)}  alt={job.company_name} height="150px" width="150px" className="lazyload" />
                        : <svg><use xlinkHref={`#company-logo-placeholder`} /></svg>
                    :
                        job.company_file_name ?
                            <img data-src={getPublicUrl(job.company_file_name)} alt={job.company_name} height="150px" width="150px" className="lazyload" />
                    : <svg><use xlinkHref={`#company-logo-placeholder`} /></svg>}
                </CardImage>
                <CardDescription>
                    <Link to={generatePath(routes.JobsDetailByUrlSlug, {'industry': job.field_of_work, 'slug': job.slug})}><H3>{job?.title}</H3></Link>
                    <Link to={job.company_slug ? generatePath(routes.EmployerDetails, {'company_slug': job.company_slug}) : ''}><P>{job.company_name}</P></Link>
                </CardDescription>
                <CardFooter>
                {job.locations && job.remote === 0 ?
                    <span>
                        <svg><use xlinkHref={`#location`} /></svg>
                        {job.locations && job.locations.length > 0 && job.locations[0].country ? <div><span>{getCountryByCode(job.locations[0].country)}</span></div> : null}
                        {job.locations && job.locations.length > 0 && job.locations[0].city ? ', ' : null}
                        <CardCities>
                            {job?.locations && job?.locations.length > 0 ?
                                job.locations.map((location: any, i: number) => {
                                    return (
                                        <span key={i}>
                                            <Link to={`/pronadji-posao/grad/${location.city_slug}`}>
                                                {location.city}
                                            </Link>
                                        </span>
                                    )
                                })
                            : null}
                        </CardCities>
                    </span>
                : job.remote === 1 ?
                <span>
                    <svg><use xlinkHref={`#location`} /></svg>
                    <FormattedMessage {...generalMessages.WorkFromHome} />
                </span>
                : null}
                    <CardDate>
                        <FormattedMessage {...generalMessages.jobExpired}/>: {job.expires_at ? formatDatefromString(job.expires_at) : null}
                    </CardDate>
                </CardFooter>
            </Card>
        : null
    )
}

export default memo(JobCard);
